module.exports = __webpack_public_path__ + "img/img1.237506c2.jpg";